import React from 'react';
import './BlogPost.css';

import logo1 from '../../images/social-media-contrib.jpg'

class BlogPost extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Guten Rutsch!     -     28. Dezember 2018</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="Probefoto 2018" src={logo1} />
        </div>
        <div className="blogpost-text">
            Hey Freunde, es wird wieder geprobt. Party Musik für die nächste Saison gibt es ja auch genug ;) Wir hoffen ihr hattet schöne Weihnachtsfeiertage und wünschen euch schon jetzt einen guten Rutsch in's neue Jahr. In diesem Sinne: Rock On!
            Eure Red Lines!
        </div>
      </div>
    </div>
    )
  }
}

export default BlogPost;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost.js